const errorLog: string[] = [];

function debug(message: any, ...optionalParams: any[]) {
    if (console && console.debug) {
        console.debug(message, ...optionalParams);
    }
}

function log(message: any, ...optionalParams: any[]) {
    if (console && console.log) {
        console.log(message, ...optionalParams);
    }
}

function warn(message: any, ...optionalParams: any[]) {
    if (console && console.warn) {
        console.warn(message, ...optionalParams);
    }
}

function error(message: any, ...optionalParams: any[]) {
    if (console && console.error) {
        console.error(message, ...optionalParams);
    }
    errorLog.unshift(JSON.stringify(message, undefined, 2));
}

function getErrorLog() {
    return errorLog.join("\n");
}

export default {
    debug: debug,
    log: log,
    warn: warn,
    error: error,
    getErrorLog: getErrorLog
};
